import { translation } from 'I18n/i18n'
import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import SolutionResine from './solutionResine/solutionResine'
import englishCondition from '../englishAssert'

interface IProps {
   visiteur?:boolean
}

export default function Environnement(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'environnement', 'title'))
      setAnchorButton(translation(lang, 'environnement', 'anchorBtns'))
   }, [])

   return (
      <ScrollContainer>
         {<AnchorPart anchor={{partName: translation(lang, 'environnement', 'anchors')[0], id: 0}}/>}
         <ScrollSection zoneName='Politique environnement' />
         {<AnchorPart anchor={{partName: translation(lang, 'environnement', 'anchors')[1], id: 1}}/>}
         <ScrollSection zoneName={`${englishCondition(lang, props.visiteur) ? "Sustainability approach" : 'Approche environnement' }`} />
         {<AnchorPart anchor={{partName: translation(lang, 'environnement', 'anchors')[2], id: 2}}/>}
         <SolutionResine />
      </ScrollContainer>
   )
}
